import Component from 'vue-class-component'
import Vue from 'vue'
import EditButton from '@/components/buttons/EditButton';
import ReferencePreview from '@/components/shared/ReferencePreview';
import ToggleButton from '@/components/buttons/ToggleButton';

@Component({
  props: ['label', 'references', 'isEditable', 'model', 'hidden'],
  components: { 'edit-button' : EditButton, 'toggle-button' : ToggleButton, 'reference-preview' : ReferencePreview }
})
export default class References extends Vue {
  protected isEditing = false;

  protected isHidden = true;

  mounted () {
    const hidden = this.$props['hidden']
    if (hidden != null) this.isHidden = hidden;
  }

  protected show (): void {
    this.isHidden = false;
  }

  protected hide (): void {
    this.isHidden = true;
  }

  protected edit (): void {
    this.isEditing = true;
  }

  protected stopEdit (): void {
    this.isEditing = false;
  }
}
